import React, { useState } from 'react'
import styles from './style.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { validateFunctionalForm } from '../../utils'

const Add = ({ onSubmit, initialValues, onClose }) => {

    const [state, setState] = useState({
        name: {
            name: "name",
            value: initialValues ? initialValues.SUB_USER_FULL_NAME : "",
            options: [],
            error: "",
            isRequired: true,
        },
        email: {
            name: "email",
            value: initialValues ? initialValues.SUB_USER_EMAIL_ID : "",
            options: [],
            error: "",
            isRequired: true,
        },
        status: {
            name: "status",
            value: initialValues ? initialValues.STATUS : "",
            options: [],
            error: "",
            isRequired: true,
        },
        phone: {
            name: "phone",
            value: initialValues ? initialValues.SUB_USER_PHONE : "",
            options: [],
            error: "",
            isRequired: true,
        },
        username: {
            name: "username",
            value: initialValues ? initialValues.SUB_USER_USERNAME : "",
            options: [],
            error: "",
            isRequired: true,
        },
        password: {
            name: "password",
            value: "",
            options: [],
            error: "",
            isRequired: initialValues ? false : true,
        },
    })

    const onChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
            },
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            let data = {
                name: state.name.value,
                email: state.email.value,
                status: state.status.value,
                phone: state.phone.value,
                username: state.username.value,
                password: state.password.value,
            };
            if (initialValues) {
                data.SUB_USER_ID = initialValues.SUB_USER_ID
            }
            onSubmit(data)
        }
    };

    return (
        <React.Fragment>

            <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                    <div className="col-md-12">
                        <label htmlFor="fullName" className={`${styles['form-labelctm']} form-label`}>
                            Full name <span className="text-danger">*</span>
                        </label>

                        <input type="text" className={`${styles['form-controlctm']} form-control ${state.name.error ? 'is-invalid' : ''}`} id="fullName"
                            placeholder='Enter the Full Name'
                            name={state.name.name}
                            value={state.name.value}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label htmlFor="email" className={`${styles['form-labelctm']} form-label`}>
                            Employee Email ID <span className="text-danger">*</span>
                        </label>
                        <input type="email" className={`${styles['form-controlctm']} form-control ${state.email.error ? 'is-invalid' : ''}`} id="email" placeholder="Enter email id"
                            name={state.email.name}
                            value={state.email.value}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="phoneNumber" className={`${styles['form-labelctm']} form-label`}>
                            Phone Number <span className="text-danger">*</span>
                        </label>
                        <input type="tel" className={`${styles['form-controlctm']} form-control  ${state.phone.error ? 'is-invalid' : ''}`} id="phoneNumber" placeholder="Enter phone number"

                            name={state.phone.name}
                            value={state.phone.value}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mb-3">

                    <div className="col-md-6">
                        <label htmlFor="username" className={`${styles['form-labelctm']} form-label`}>
                            Create Username <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                            <input type="text" className={`${styles['form-controlctm']} form-control  ${state.username.error ? 'is-invalid' : ''}`} id="username" placeholder="Create Username"
                                name={state.username.name}
                                value={state.username.value}
                                onChange={onChange}
                            />

                        </div>
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="password" className={`${styles['form-labelctm']} form-label`}>
                            Create password {state.password.isRequired && <span className="text-danger">*</span>}
                        </label>
                        <div className="input-group position-relative">
                            <input type="password" className={`${styles['form-controlctm']} form-control  ${state.password.error ? 'is-invalid' : ''}`} id="password" placeholder="Create password"
                                name={state.password.name}
                                value={state.password.value}
                                onChange={onChange}
                            />
                            <a href="#" className={`${styles['eye-link']}`}><FontAwesomeIcon icon={faEye} /></a>
                        </div>
                    </div>
                </div>
                <div className="mb-3">
                    <label className={`${styles['form-labelctm']} form-label`}>
                        Status <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex">
                        {/* Active Status */}
                        <div className="form-check d-flex align-items-center me-3">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="status"
                                id="active"
                                checked={state.status.value === 'A'}
                                onChange={() =>
                                    setState((prevState) => ({
                                        ...prevState,
                                        status: {
                                            ...prevState.status,
                                            value: 'A',
                                        },
                                    }))
                                }
                            />
                            <label className="form-check-label ps-2" htmlFor="active">
                                Active
                            </label>
                        </div>

                        {/* Inactive Status */}
                        <div className="form-check d-flex align-items-center me-3">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="status"
                                id="inactive"
                                checked={state.status.value === 'I'}  // Fixed checked condition
                                onChange={() =>
                                    setState((prevState) => ({
                                        ...prevState,
                                        status: {
                                            ...prevState.status,
                                            value: 'I',
                                        },
                                    }))
                                }
                            />
                            <label className="form-check-label ps-2" htmlFor="inactive">
                                Inactive
                            </label>
                        </div>
                    </div>
                </div>

                <hr />
                <div className="d-flex justify-content-end">
                    <button type="button" className={`${styles['cancel-btn']} btn me-2`}
                        onClick={() => {
                            onClose()
                        }}
                    >
                        Cancel
                    </button>
                    <button type="submit" className={`${styles['add-btn']} btn`}>
                        Add New User
                    </button>
                </div>
            </form>
        </React.Fragment>
    )
}

export default Add